import { ReactComponent as Warning } from '../../../assets/icons/warning.svg'
import { ReactComponent as WarningCircle } from '../../../assets/icons/warning-circle.svg'
import { ReactComponent as ShieldCheck } from '../../../assets/icons/shield-check.svg'

import theme from '../base'

const alert = {
  MuiAlert: {
    defaultProps: {
      iconMapping: {
        error: <Warning />,
        info: <WarningCircle />,
        success: <ShieldCheck />,
        warning: <Warning />,
      },
    },
    styleOverrides: {
      root: {
        alignItems: 'center',
        padding: theme.spacing(1.5, 2),
      },
      message: {
        ...theme.typography.label,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        flex: 1,

        '& .MuiTypography-h3medium, & .MuiTypography-h4': {
          marginBottom: theme.spacing(0.5),
        },

        '& .MuiLink-root': {
          ...theme.typography.body2,
          margin: theme.spacing(0.5, 0, 0, 'auto'),
          color: 'inherit',
        },

        '& .MuiButton-root': {
          margin: theme.spacing(1, 0, 0, 'auto'),
        },
      },
      icon: {
        marginRight: theme.spacing(1),
        padding: 0,
        alignSelf: 'flex-start',

        '& svg': {
          width: 25,
          height: 24,
        },
      },
      standardInfo: {
        maxWidth: 480,
        backgroundColor: theme.palette.info.light,
        color: theme.palette.turquoise.darkest,

        '& .MuiAlert-icon': {
          color: 'inherit',
        },
        '& .MuiLink-root': {
          '&::after': {
            backgroundColor: theme.palette.info.darkest,
          },
        },
      },
      standardWarning: {
        maxWidth: 480,
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.warning.darkest,

        '& .MuiAlert-icon': {
          color: 'inherit',
        },
        '& .MuiLink-root': {
          '&::after': {
            backgroundColor: theme.palette.warning.darkest,
          },
        },
      },
      standardError: {
        maxWidth: 480,
        backgroundColor: theme.palette.error.light,
        color: theme.palette.error.dark,

        '& .MuiAlert-icon': {
          color: 'inherit',
        },
        '& .MuiLink-root': {
          '&::after': {
            backgroundColor: theme.palette.info.darkest,
          },
        },
      },
      standardSuccess: {
        maxWidth: 480,
        backgroundColor: theme.palette.success.light,
        color: theme.palette.success.darkest,

        '& .MuiAlert-icon': {
          color: 'inherit',
        },
        '& .MuiLink-root': {
          '&::after': {
            backgroundColor: theme.palette.success.darkest,
          },
        },
      },
    },
  },
}

export default alert
